<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月20日 10:55:31 +0800
 * @最后修改时间: 2021-11-17 17:02:40
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Shift\ShiftList\components\mapEventShift.vue
 -->
<template>
  <normalDialog
    width="680"
    :dialog="show"
    maxWidth="680"
    :title="title"
    @close="closeMappingDialog"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_shift_form_dialog_eventTypeLabel"
              :items="EventType"
              v-model="curType"
              :rules="$GetRules(['_Require_Rules'], [null])"
              item-text="event_type_name"
              item-value="uuid"
            >
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_shift_form_dialog_eventNameLabel"
              :items="activeEventList"
              v-model="curEvent"
              :rules="$GetRules(['_Require_Rules'], [null])"
              item-text="event_business_name"
              item-value="uuid"
            >
            </AutoComplete>
          </v-col>
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="12"
            cols="12"
            class="mt-n5"
            v-if="curEventObject != null"
          >
            <v-sheet
              width="100%"
              elevation="0"
              color="grey lighten-4"
              class="pa-6"
            >
              <v-row>
                <v-col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  cols="12"
                  class="pt-0 pb-0"
                >
                  <v-sheet class="text--secondary pl-1 transparent">{{
                    $t("label_essweb_shift_form_dialog_eventDescriptionLabel")
                  }}</v-sheet>
                  <v-text-field
                    :label="
                      $t('label_essweb_shift_form_dialog_eventDescriptionLabel')
                    "
                    single-line
                    :value="
                      $getCommonLangValue(
                        curEventObject.event_business_description
                      )
                    "
                    filled
                    :disabled="true"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12" class="pt-0 pb-0">
                  <v-sheet class="text--secondary pl-1 transparent">{{
                    $t("label_essweb_shift_form_dialog_startTimeLabel")
                  }}</v-sheet>
                  <v-text-field
                    :label="$t('label_essweb_shift_form_dialog_startTimeLabel')"
                    single-line
                    filled
                    :disabled="true"
                    :value="$timeMachine(curEventObject.start_utc_time)"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12" class="pt-0 pb-0">
                  <v-sheet class="transparent text--secondary">{{
                    $t("label_essweb_shift_form_dialog_startTimeZoneLabel")
                  }}</v-sheet>
                  <v-select
                    :items="staticZone"
                    v-model="curEventObject.start_time_time_zone"
                    single-line
                    dense
                    append-icon=""
                    :menu-props="{
                      offsetY: true,
                      transition: 'slide-y-transition',
                      rounded: true,
                      contentClass: 'elevation-4',
                    }"
                    :disabled="true"
                    item-text="text"
                    item-value="utc"
                    filled
                  >
                    <template v-slot:no-data> <noContent /> </template>
                  </v-select>
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12" class="pt-0 pb-0">
                  <v-sheet class="transparent text--secondary">{{
                    $t("label_essweb_shift_form_dialog_endTimeLabel")
                  }}</v-sheet>
                  <v-text-field
                    :label="$t('label_essweb_shift_form_dialog_endTimeLabel')"
                    single-line
                    :value="$timeMachine(curEventObject.end_utc_time)"
                    filled
                    :disabled="true"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12" class="pt-0 pb-0">
                  <v-sheet class="transparent text--secondary">{{
                    $t("label_essweb_shift_form_dialog_endTimeZoneLabel")
                  }}</v-sheet>
                  <v-select
                    :items="staticZone"
                    v-model="curEventObject.end_time_time_zone"
                    single-line
                    dense
                    append-icon=""
                    :menu-props="{
                      offsetY: true,
                      transition: 'slide-y-transition',
                      rounded: true,
                      contentClass: 'elevation-4',
                    }"
                    :disabled="true"
                    item-text="text"
                    item-value="utc"
                    filled
                  >
                    <template v-slot:no-data> <noContent /> </template>
                  </v-select>
                </v-col>
                <v-col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  cols="12"
                  class="pt-0 pb-0"
                >
                  <v-sheet class="transparent text--secondary">{{
                    $t("label_essweb_shift_form_dialog_totalMinuteLabel")
                  }}</v-sheet>
                  <v-text-field
                    :label="
                      $t('label_essweb_shift_form_dialog_totalMinuteLabel')
                    "
                    single-line
                    :value="
                      Number(curEventObject.end_utc_time) -
                      Number(curEventObject.start_utc_time)
                    "
                    filled
                    :disabled="true"
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions
        :newBtn="action == 'new'"
        :saveBtn="action == 'edit'"
        @new="newMapping"
        @save="editMapping"
        @cancel="closeMappingDialog"
      />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "mapEventShift",
  props: {
    show: { default: false, type: Boolean },
    mapData: { type: Object },
    action: { default: "new", type: String },
  },
  computed: {
    title() {
      return this.action == "new"
        ? this.$t("label_essweb_shift_form_dialog_newEventTitle")
        : this.$t("label_essweb_shift_form_dialog_editEventTitle");
    },
    ...mapGetters(["staticZone"]),

    activeEventList() {
      var arr = [];
      const that = this;
      if (this.curType) {
        this.EventList.forEach(function (item) {
          if (item.event_type_uuid == that.curType) {
            arr.push(item);
          }
        });
      }
      return arr;
    },
    EventType() {
      return this.$getSelectTrans(this.EventTypeData, "event_type_name");
    },
    EventList() {
      return this.$getSelectTrans(this.EventListData, "event_business_name");
    },
  },
  watch: {
    mapData(val) {
      this.curId = val.id;
      this.curType = val.curType;
      this.temType = val.curType;
      this.curEvent = val.curEvent;
      this.temEvent = val.curEvent;
    },
    curType(val, oldval) {
      const that = this;
      if (oldval) {
        this.curEvent = "";
      }
      that.curTypeObject = null;
      if (val) {
        this.EventTypeData.forEach(function (item) {
          if (item.uuid == val) {
            that.curTypeObject = item;
          }
        });
      } else {
        that.curTypeObject = null;
      }
    },
    curEvent(val) {
      const that = this;
      that.curEventObject = null;
      if (val) {
        this.EventListData.forEach(function (item) {
          // item.event_business_name = that.$getCommonLangValue(
          //   item.event_business_name
          // );
          // item.event_business_description = that.$getCommonLangValue(
          //   item.event_business_description
          // );
          if (item.uuid == val) {
            that.curEventObject = item;
            that.curGroupUuid = item["event_property_group_uuid"];
          }
        });
      } else {
        that.curEventObject = null;
      }
    },
  },
  data() {
    return {
      curType: "",
      curId: null,
      curEvent: "",
      curGroupUuid: null,
      temType: "",
      temEvent: "",
      curTypeObject: null,
      curEventObject: null,
      EventTypeData: [],
      EventListData: [],
    };
  },
  mounted() {
    this.getEventType();
    this.getEventList();
  },
  methods: {
    closeMappingDialog: function () {
      this.$emit("closeDialog");
    },
    getEventList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_event",
        url: "/event/get-event-list/",
      }).then((res) => {
        that.EventListData = res.data;
      });
    },
    getEventType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "event_event_type",
        url: "/event-type/get-event-type-list/",
      }).then((res) => {
        that.EventTypeData = res.data;
      });
    },
    editMapping: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      var obj = {
        id: this.curId,
        temp_type: this.temType,
        temp_event: this.temEvent,
        group_uuid: this.curGroupUuid,
        type_uuid: this.curTypeObject.uuid,
        type: this.curTypeObject.event_type_name,
        event_uuid: this.curEventObject.uuid,
        name: this.curEventObject.event_business_name,
        startTime: this.curEventObject.start_utc_time,
        startUtc: this.curEventObject.start_time_time_zone,
        endTime: this.curEventObject.end_utc_time,
        endUtc: this.curEventObject.end_time_time_zone,
      };
      this.$emit("edit", obj);
    },
    newMapping: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      var obj = {
        id: null,
        type_uuid: this.curTypeObject.uuid,
        group_uuid: this.curGroupUuid,
        type: this.curTypeObject.event_type_name,
        event_uuid: this.curEventObject.uuid,
        name: this.curEventObject.event_business_name,
        startTime: this.curEventObject.start_utc_time,
        startUtc: this.curEventObject.start_time_time_zone,
        endTime: this.curEventObject.end_utc_time,
        endUtc: this.curEventObject.end_time_time_zone,
      };
      this.$emit("new", obj);
    },
  },
};
</script>
